import * as THREE from 'three'

export default new THREE.MeshStandardMaterial({
  color: 0xbbbbff,
  roughness: 0.1,
  transparent: true,
  opacity: 0.42,
  metalness: 0,
  emissive: 0x303030,
  side: THREE.DoubleSide
  //depthTest: false,
  //depthWrite: false,
})